import { useEffect } from 'react';
import ContextAdsHero from './components/ContextAdsHero';
import ContextAdsWhatIs from './components/ContextAdsWhatIs';
import ContextAdsWhySite from './components/ContextAdsWhySite';
import ContextAdsProcess from './components/ContextAdsProcess';
import ContextAdsResultsBlock from './components/ContextAdsResultsBlock';
import ContextAdsMetrics from './components/ContextAdsMetrics';
import ContextAdsLeadForm from './components/ContextAdsLeadForm';
import Footer from '../landing-page/components/Footer';
import { useSEO } from '../../utils/seo';

export default function ContextAdsPage() {
  useSEO({
    title: 'Контекстная реклама Google и Яндекс Директ | Профессиональная настройка в Москве',
    description: 'Профессиональная настройка контекстной рекламы в Google Ads и Яндекс Директ. Горячие клиенты из поиска, медиапланирование, UTM-аналитика, ИИ-оптимизация ставок.',
    keywords: 'контекстная реклама, Яндекс Директ, Google Ads, настройка рекламы, performance-маркетинг',
    canonical: '/context-ads',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <ContextAdsHero />
      <ContextAdsWhatIs />
      <ContextAdsWhySite />
      <ContextAdsProcess />
      <ContextAdsResultsBlock />
      <ContextAdsMetrics />
      <ContextAdsLeadForm />
      <Footer />
    </div>
  );
}
